var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.notbanner)?_c('jt-header'):_vm._e(),_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"content",attrs:{"id":"contents"}},[_c('router-view',{on:{"isShowHeader":_vm.isShowHeader}}),(this.$root.COZEID)?_c('CozeChat'):_vm._e()],1)]),(!_vm.notbanner)?_c('jt-footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }